import React from "react";
import styles from "../../styles/screens/PrasadBox/PrasadBox.module.css";
import KrishnaDarbar from "../../assets/prasad_gift/Krishna_Darbar.png";
import RamDarbar from "../../assets/prasad_gift/Ram_Darbar.png";
import { useNavigate } from "react-router-dom";
const PGHero = ({ productId }) => {
  const backgroundImage = productId === "ramdarbar" ? RamDarbar :KrishnaDarbar;
  const title = productId === "ramdarbar" ? "Ram Darbar" : "Krishna Darbar";
  const navigate = useNavigate();
  const navigateToProductCheckout = () => {
    navigate(`/dharmikx/checkout/${productId}`);
  }

  return (
    <div
      className={styles.heroContainer}
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className={styles.heroContent}>
        <h1 className={styles.heroTitle}>
          {title}
        </h1>
        <button className={styles.orderButton} onClick={navigateToProductCheckout}>ORDER NOW</button>
      </div>
    </div>
  );
};

export default PGHero;
